module.exports = __webpack_public_path__ + "img/carFooter.462fa8b9.png";